import { Badge, Tooltip } from '@chakra-ui/react';
import type { PolicyNumberVerdict } from '../hooks/useMvrCarrierRules';

interface MvrPolicyNumberBadgeProps {
  verdict: PolicyNumberVerdict;
  expectedPatternText?: string | null;
}

const VERDICT_PRESENTATION: Record<
  Exclude<PolicyNumberVerdict, null>,
  { label: string; colorScheme: string }
> = {
  valid: { label: 'Format Valid', colorScheme: 'green' },
  mismatch: { label: 'Format Mismatch', colorScheme: 'red' },
  soft: { label: 'Unconfirmed Format', colorScheme: 'yellow' },
  unknown: { label: 'Verify Manually', colorScheme: 'gray' },
};

const MvrPolicyNumberBadge = ({
  verdict,
  expectedPatternText = null,
}: MvrPolicyNumberBadgeProps) => {
  const presentation = verdict ? VERDICT_PRESENTATION[verdict] : null;

  const badge = (
    <Badge
      colorScheme={presentation?.colorScheme ?? 'gray'}
      variant="outline"
      fontSize="xs"
      fontWeight="500"
      py={1}
      visibility={presentation ? 'visible' : 'hidden'}
    >
      {presentation?.label ?? 'placeholder'}
    </Badge>
  );

  if (!presentation || !expectedPatternText) {
    return badge;
  }

  return <Tooltip label={expectedPatternText}>{badge}</Tooltip>;
};

export default MvrPolicyNumberBadge;
